/**
 * Redux store configuration with Redux Toolkit
 * Migrated from Gatsby legacy application
 */
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import outlookReducer from './slices/outlookSlice';
import navigationReducer from './slices/navigationSlice';

/**
 * Configure the Redux store with all slices
 */
const store = configureStore({
  reducer: {
    outlook: outlookReducer,
    navigation: navigationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Enable listener behavior for the store
setupListeners(store.dispatch);

export default store;
